













export default {
    name: 'BaseAlertList',
    components: {},
    props: {
        errors: Array,
    },
    data() {
        return {};
    },
    methods: {},
};
